module.exports = __webpack_public_path__ + "static/15112018_WARUNKI_CYNKOWANIA-f92fff039ef9fef4c3f8f06a6259e4ba.pdf";